var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64.02 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;fill:url(#D\xE9grad\xE9_sans_nom_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    y1: 26,
    x2: 64.02,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8452a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5ca8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.24,41.76a2,2,0,0,1,0-2.83l5.66-5.66a2,2,0,1,1,2.83,2.83l-5.66,5.66a2,2,0,0,1-2.83,0Zm40.69,0L45.27,36.1a2,2,0,0,1,2.83-2.83l5.66,5.66a2,2,0,0,1-2.83,2.83ZM61.7,11.66l-24,22a8,8,0,0,1-11.32,0L12.24,19.59h0L7.48,14.84h0A2,2,0,0,0,6,14a2,2,0,0,0-2,2V44a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V20a2,2,0,0,1,4,0V44a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V16a6,6,0,0,1,6-6,5.83,5.83,0,0,1,4,1.73v0L29.17,30.87a4,4,0,0,0,5.66,0l24-22A3.94,3.94,0,0,0,60,6h0c0-2.21-1.79-2-4-2H14a2,2,0,0,1,0-4H56c3.67,0,6.76,1.1,7.7,4h.06a8,8,0,0,1-2.06,7.66ZM6,4A2,2,0,1,1,8,2,2,2,0,0,1,6,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.84125720404e14bddf7a4ab856210239.svg";
export { ForwardRef as ReactComponent };